function LinkIcon() {
    return React.createElement('svg', {
        width: '16',
        height: '16',
        viewBox: '0 0 40 40',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        className: 'popup-link-icon'
    },
        React.createElement('path', {
            d: 'M33.75 16.25L33.7484 6.25156L23.75 6.25M21.25 18.75L33.75 6.25',
            stroke: 'rgba(255, 255, 255, 0.45)',
            strokeWidth: '3',
            strokeLinecap: 'round',
            strokeLinejoin: 'round'
        }),
        React.createElement('path', {
            d: 'M28.75 21.25V32.5C28.75 32.8315 28.6183 33.1495 28.3839 33.3839C28.1495 33.6183 27.8315 33.75 27.5 33.75H7.5C7.16848 33.75 6.85054 33.6183 6.61612 33.3839C6.3817 33.1495 6.25 32.8315 6.25 32.5V12.5C6.25 12.1685 6.3817 11.8505 6.61612 11.6161C6.85054 11.3817 7.16848 11.25 7.5 11.25H18.75',
            stroke: 'rgba(255, 255, 255, 0.45)',
            strokeWidth: '3',
            strokeLinecap: 'round',
            strokeLinejoin: 'round'
        })
    );
}

function SkeletonLoader(props) {
    var count = props.count || 4;
    var items = [];
    for (var i = 0; i < count; i++) {
        items.push(
            React.createElement('div', { key: i, className: 'skeleton-wrapper' },
                React.createElement('div', { className: 'skeleton-option' },
                    React.createElement('div', { className: 'skeleton skeleton-image' }, '\u00A0')
                ),
                React.createElement('div', { className: 'skeleton skeleton-text' }, '\u00A0'),
                React.createElement('div', { className: 'skeleton skeleton-price' }, '\u00A0')
            )
        );
    }
    return React.createElement(React.Fragment, null, items);
}

function ProductCard(props) {
    var product = props.product;
    var isSelected = props.isSelected;
    var onSelect = props.onSelect;
    var onTooltipClick = props.onTooltipClick;
    var showPrice = props.showPrice;
    var getImageUrl = props.getImageUrl;
    
    var imageLoadedState = React.useState(false);
    var imageLoaded = imageLoadedState[0];
    var setImageLoaded = imageLoadedState[1];
    
    var imageErrorState = React.useState(false);
    var imageError = imageErrorState[0];
    var setImageError = imageErrorState[1];
    
    var imageUrl = getImageUrl ? getImageUrl(product) : 
                   (product.metafields && product.metafields['custom.customization_thumbnail']) || 
                   product.image || '';
    
    React.useEffect(function() {
        setImageLoaded(false);
        setImageError(false);
        if (!imageUrl) {
            setImageLoaded(true);
            return;
        }
        var img = new Image();
        img.onload = function() { setImageLoaded(true); };
        img.onerror = function() {
            setImageError(true);
            setImageLoaded(true);
        };
        img.src = imageUrl;
    }, [imageUrl]);
    
    return React.createElement('div', { 
        className: 'knife-option-wrapper', 
        onClick: function() { onSelect(product.id); }
    },
        React.createElement('div', { 
            className: 'knife-option' + (isSelected ? ' selected' : '') 
        },
            React.createElement('img', { 
                src: 'https://cdn.prod.website-files.com/68d5e9e73859fd3ba297c9c2/68db4ef3733a819133e47c95_card--tool-tip.svg', 
                alt: 'tooltip', 
                className: 'knife-tooltip', 
                onClick: function(e) { onTooltipClick(e, product); }
            }),
            React.createElement('div', { className: 'knife-placeholder' },
                !imageLoaded ? 
                    React.createElement('div', { className: 'card-skeleton-shimmer' }) :
                    (imageUrl && !imageError) ? 
                        React.createElement('img', { 
                            src: imageUrl, 
                            alt: product.name,
                            className: 'card-image-fade-in'
                        }) : 
                        '\u00A0'
            )
        ),
        React.createElement('div', { className: 'knife-name' }, product.name),
        showPrice && React.createElement('div', { className: 'knife-price' }, formatPrice(product.price))
    );
}

function ProductPopup(props) {
    var isOpen = props.isOpen;
    var onClose = props.onClose;
    var product = props.product;
    var imageType = props.imageType;
    
    var showImageState = React.useState(false);
    var showImage = showImageState[0];
    var setShowImage = showImageState[1];
    
    var lastProductIdRef = React.useRef(null);
    
    var previewImage = '';
    if (product) {
        if (imageType === 'shape' && shapeImages[product.id]) {
            previewImage = shapeImages[product.id];
        } else if (product.image) {
            previewImage = product.image;
        }
    }
    
    var showSkeleton = !showImage;
    var isShapeImage = imageType === 'shape';
    
    // preload
    React.useEffect(function() {
        if (!isOpen || !product) return;
        var productId = product.id;
        if (lastProductIdRef.current === productId) return;
        lastProductIdRef.current = productId;
        setShowImage(false);
        
        if (!previewImage) {
            setShowImage(true);
            return;
        }
        
        var img = new Image();
        img.onload = function() { setShowImage(true); };
        img.onerror = function() { setShowImage(true); };
        img.src = previewImage;
    }, [isOpen, product, previewImage]);
    
    // reset
    React.useEffect(function() {
        if (!isOpen) {
            setShowImage(false);
            lastProductIdRef.current = null;
        }
    }, [isOpen]);
    
    // escape
    React.useEffect(function() {
        var handleEscape = function(e) {
            if (e.key === 'Escape') onClose();
        };
        if (isOpen) document.addEventListener('keydown', handleEscape);
        return function() { document.removeEventListener('keydown', handleEscape); };
    }, [isOpen, onClose]);
    
    if (!product) return null;
    if (typeof window.antd === 'undefined') return null;
    
    var Tabs = window.antd.Tabs;
    var ConfigProvider = window.antd.ConfigProvider;
    var theme = window.antd.theme;
    
    var specifications = getSpecifications(product, imageType);
    var recommendedHandles = imageType === 'blade' ? getRecommendedHandles(product) : [];
    
    var tabItems = [
        {
            key: '1',
            label: 'Description',
            children: React.createElement('div', { className: 'popup-description' }, product.description)
        }
    ];
    
    if (imageType !== 'shape') {
        var specsContent = React.createElement('div', { className: 'product-specs-section' },
            React.createElement('div', { className: 'product-specs-container' },
                React.createElement('div', { className: 'specs-table-wrapper' },
                    React.createElement('table', { className: 'specs-table' },
                        React.createElement('tbody', null,
                            specifications.map(function(spec, index) {
                                return React.createElement('tr', { key: index },
                                    React.createElement('td', { className: 'spec-label' }, spec.label),
                                    React.createElement('td', { className: 'spec-value' }, spec.value)
                                );
                            })
                        )
                    )
                ),
                imageType === 'blade' && recommendedHandles.length > 0 &&
                    React.createElement('div', { className: 'recommended-handles-section' },
                        React.createElement('div', { className: 'recommended-handles-title' }, 'Recommended Handles'),
                        React.createElement('div', { className: 'recommended-handles-grid' },
                            recommendedHandles.map(function(handle, index) {
                                return React.createElement('div', { key: index, className: 'recommended-handle-item' },
                                    React.createElement('div', { className: 'recommended-handle-image' },
                                        handle.image ?
                                            React.createElement('img', { src: handle.image, alt: handle.title }) :
                                            React.createElement('span', { className: 'recommended-handle-no-image' }, 'No image')
                                    ),
                                    React.createElement('span', { className: 'recommended-handle-title' }, handle.title)
                                );
                            })
                        )
                    )
            )
        );
        tabItems.push({ key: '2', label: 'Specifications', children: specsContent });
    }
    
    // shape: width-based, others: height-based
    var imageStyle = isShapeImage ? 
        { width: '100%', height: 'auto', objectFit: 'contain', opacity: showSkeleton ? 0 : 1, transition: 'opacity 0.3s ease-out' } :
        { height: '100%', minWidth: '100%', objectFit: 'cover', opacity: showSkeleton ? 0 : 1, transition: 'opacity 0.3s ease-out' };
    
    return React.createElement('div', { 
        className: 'popup-overlay' + (isOpen ? ' active' : ''), 
        onClick: onClose
    },
        React.createElement('div', { 
            className: 'popup-content',
            onClick: function(e) { e.stopPropagation(); }
        },
            React.createElement('button', { className: 'popup-close', onClick: onClose },
                React.createElement('svg', { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24' },
                    React.createElement('path', { 
                        strokeLinecap: 'round', 
                        strokeLinejoin: 'round', 
                        strokeWidth: 2, 
                        d: 'M6 18L18 6M6 6l12 12' 
                    })
                )
            ),
            
            React.createElement('div', { 
                className: 'popup-image-container' + (isShapeImage ? ' popup-image-container--shape' : '')
            },
                previewImage && React.createElement('div', {
                    className: 'popup-image-skeleton',
                    style: {
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(90deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.03) 100%)',
                        backgroundSize: '200% 100%',
                        animation: 'popupImageShimmer 2s infinite ease-in-out',
                        borderRadius: '2px',
                        opacity: showSkeleton ? 1 : 0,
                        transition: 'opacity 0.2s ease-out',
                        pointerEvents: 'none'
                    }
                }),
                previewImage && React.createElement('img', {
                    key: product.id,
                    src: previewImage,
                    alt: product.name,
                    className: 'popup-image',
                    style: imageStyle
                })
            ),
            
            React.createElement('div', { className: 'popup-title-row' },
                React.createElement('h3', { className: 'popup-title' }, product.name),
                imageType !== 'shape' && React.createElement('a', {
                    href: '/products/' + product.id,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    className: 'popup-view-product-btn',
                    onClick: function(e) { e.stopPropagation(); }
                }, 'View Product', React.createElement(LinkIcon))
            ),
            
            imageType !== 'shape' && React.createElement('p', { className: 'popup-price' },
                React.createElement('strong', null, 'Price:'), ' ' + formatPrice(product.price)
            ),
            
            React.createElement(ConfigProvider, {
                theme: {
                    algorithm: theme.darkAlgorithm,
                    token: {
                        colorPrimary: 'rgba(255, 255, 255, 0.6)',
                        colorBgContainer: '#1a1a1a',
                        colorBorder: 'rgba(255, 255, 255, 0.2)',
                        colorText: 'rgba(255, 255, 255, 0.6)',
                        colorTextSecondary: 'rgba(255, 255, 255, 0.45)',
                        fontSize: 14,
                        borderRadius: 2
                    },
                    components: {
                        Tabs: {
                            inkBarColor: 'rgba(255, 255, 255, 0.6)',
                            itemSelectedColor: 'rgba(255, 255, 255, 0.9)',
                            itemColor: 'rgba(255, 255, 255, 0.45)',
                            itemHoverColor: 'rgba(255, 255, 255, 0.7)'
                        }
                    }
                }
            },
                React.createElement(Tabs, {
                    defaultActiveKey: '1',
                    className: 'popup-tabs',
                    items: tabItems
                })
            )
        )
    );
}